<script>
  import BScroll from 'better-scroll'
  import { BROWSER_TIME } from 'base/config'

  export default {
    name: 'ScrollView',
    props: {
      propBtn: {
        type: Boolean,
        default: true
      },
      propPromptBtn: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        promptBtn: this.propPromptBtn
      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {
      setTimeout(() => {
        this._initScroll()
      }, BROWSER_TIME)
    },
    methods: {
      _initScroll() {
        if (!this.$refs.wrapper) return
        this.scroll = new BScroll(this.$refs.wrapper, {
          scrollX: true,
          eventPassthrough: 'vertical',
          probeType: 3,
          tap: true
        })
        // this.scroll.on('scroll', (pos) => {

        // })

        if (this.promptBtn) {
          this.scroll.on('scrollEnd', () => {
            // 滚动到底部
            if (this.scroll.x <= (this.scroll.maxScrollX + 50)) {
              this.promptBtn = false
            } else {
              this.promptBtn = true
            }
          })
        }
      },
      promptHandler(direction) {
        const targetX = direction === 'right' ? this.scroll.maxScrollX : 0
        this.scroll.scrollTo(targetX, this.scroll.y, 500)
      }
    }
  }
</script>

<template>
  <article class="scroll-view-wrap">
    <section class="scroll-view">
      <div class="left">
        <slot name="left" />
      </div>
      <div ref="wrapper" class="main">
        <div class="slide">
          <slot name="main" />
        </div>
      </div>
      <div
        v-if="propBtn"
        class="more-item right"
        :class="{'show': promptBtn}"
        @click.stop="promptHandler('right')"
      >
        <i class="iconfont icon-arrows_right" />
      </div>
      <!--      <div class="more-item left" v-if="!promptBtn"
        @click.stop="promptHandler('left')">
        <i class="iconfont icon-arrows_right"></i>
      </div> -->
    </section>
  </article>
</template>

<style scoped>
  @import 'variable.css';

  .scroll-view {
    &:before {
      z-index: 1;
      @apply --bd-h;
      background-color: var(--primary-color-border);
      left: 0;
      top: 0;
    }
    .left {
      display: table-cell;
      width: 67px;
      text-align: center;
    }
    .main {
      overflow: hidden;
      position: relative;
      display: table-cell;
      width: 100%;
      touch-action: pan-y pinch-zoom;
      -webkit-tap-highlight-color: transparent;
      .slide {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        margin-left: -1px;
        font-size: 0;
        white-space: nowrap;
        &:after {
          @apply --bd-w;
          background-color: var(--primary-color-border);
          left: 0;
          top: 0;
        }
        .row:nth-child(2n) {
          background-color: var(--minor-color-bg);
        }
      }
    }
  }
</style>